export const heroData = {
  heroTitle: null,
  heroSubText: null,
  parallax: true,
  heroImage: {
    desktopUrl:
      "https://frontend-assets.buildbox.com/BBClassicHeaderDesktop_new.jpg",
    mobileUrl:
      "https://frontend-assets.buildbox.com/BBClassicHeroMobile_new.jpg",
    lowResDesktopImageUrl:
      "https://frontend-assets.buildbox.com/lowresBB2Hero.jpg",
  },
  showHeadrest: true,
  hasButton: true,
  heroButton: {
    buttonText: "Download Now",
    buttonLink: "/downloads/bb2",
    isLinkExternal: false,
    linkedToDownloads: true,
    borderColor: "#fff",
    backgroundColor: "transparent",
    hoverStyle: {
      borderColor: "#FFFFFF",
      buttonColor: "#FFFFFF",
      textColor: "#F16522",
    },
  },
  unfoldFuton: true,
  futonData: {
    futonLogo: "https://frontend-assets.buildbox.com/BB2_logo.svg",
    title: `The Ultimate ${"\n"} 2D Game Builder`,
    subtext:
      "Buildbox Classic is our traditional 2D game maker with drag and drop functionality. Make a game without coding!",
    backgroundImg: "",
  },
  product: "BB2",
};

export const homeObjOne = {
  product: "BB2",
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: "",
  headline: "Drag & Drop",
  description:
    "With Buildbox Classic, building 2D games and prototyping is not only simple but fast. Drag and drop your assets onto the Drop Wheel as a background, character, object, or action. Then edit to customize. There's no coding involved.",
  hasButton: false,
  hasLogo: true,
  buttonLabel: "Get Started",
  imgStart: "",
  img: "https://frontend-assets.buildbox.com/draganddrop_opt.png",
  alt: "Buildbox drag and drop",
  start: "",
  backgroundImg:
    "https://frontend-assets.buildbox.com/product_feature_1_bg.svg",
  logoSrc: "https://frontend-assets.buildbox.com/BB2_DragAndDrop.svg",
};

export const homeObjTwo = {
  product: "BB2",
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: "",
  headline: "Preset Templates",
  description:
    "Our Creator Tool automatically sets up the layout of your game for you. All you have to do is edit and customize. Choose from over 40 different built-in preset templates. Build platformers, puzzlers, shooters, racing, and sports-themed games, all without coding.",
  hasButton: false,
  hasLogo: true,
  buttonLabel: "Get Started",
  imgStart: "start",
  img: "https://frontend-assets.buildbox.com/bb2templates.png",
  alt: "Buildbox Preset Templates",
  start: "",
  backgroundImg:
    "https://frontend-assets.buildbox.com/product_feature_2_bg.svg",
  logoSrc: "https://frontend-assets.buildbox.com/BB2_PresetTemplates.svg",
};

export const homeObjThree = {
  product: "BB2",
  lightBg: false,
  lightTopLine: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "",
  headline: "Visual Effects Library",
  description:
    "Making your game unique is easy in Buildbox Classic. There are many built-in special effects like particles, lights, and trails that you can choose from and drag into any scene or attach to a character. Create animated smoke, fire, or sparks and much more.",
  hasButton: false,
  hasLogo: true,
  buttonLabel: "",
  imgStart: "",
  img: "https://frontend-assets.buildbox.com/vfx_opt.png",
  alt: "Buildbox Visual Effect Library",
  start: "true",
  backgroundImg:
    "https://frontend-assets.buildbox.com/product_feature_3_bg.svg",
  logoSrc: "https://frontend-assets.buildbox.com/BB2_VisualEffectsLibrary.svg",
};

export const homeObjFour = {
  product: "BB2",
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: "",
  headline: "Adbox Monetization",
  description:
    "Easily monetize your app with Adbox. Adbox is automatically added to your project when you toggle ads on from any UI Screen. If you are on a Pro account, you can link your AdMob account or integrate your own custom monetization partner. Start earning today!",
  hasButton: false,
  hasLogo: true,
  buttonLabel: "Get Started",
  imgStart: "start",
  img: "https://frontend-assets.buildbox.com/ez_opt.png",
  alt: "Buildbox Preset Templates",
  start: "",
  backgroundImg:
    "https://frontend-assets.buildbox.com/product_feature_4_bg.svg",
  logoSrc: "https://frontend-assets.buildbox.com/BB2_Adbox_Stacked.svg",
};

export const homeObjFive = {
  backgroundImg: "shapesBg",
  product: "BB2",
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: "",
  headline: "",
  description: "",
  buttonLabel: "Sign Up Now",
  imgStart: "start",
  img: "",
  alt: "Vault",
  start: "true",
  isCarousel: true,
  cardItems: [
    {
      title: "Tutorials",
      lightText: true,
      img: "https://frontend-assets.buildbox.com/BBClassic_Tutorial_opt.jpg",
      imgLink: "https://www.buildbox.com/tutorials-buildbox-classic/",
      description:
        "We have tutorials, manuals, and easy to access support via email or our website to help you along the way.",
      alt: "Buildbox Tutorials",
      button: true,
      buttonCTA: "Learn More",
    },
    {
      title: "Community",
      lightText: true,
      img: "https://frontend-assets.buildbox.com/Community_image_opt.jpg",
      imgLink: "https://www.buildbox.com/forum/index.php",
      description: "Join our active forums to learn how to use Buildbox.",
      alt: "Buildbox Community",
      button: true,
      buttonCTA: "Learn More",
    },
  ],
};

export const homeObjSix = {
  index: 1,
  product: "BB2",
  topLine: "Is Buildbox Classic \n right for you?",
  lightTopLine: true,
  lightBg: false,
  hasButton: true,
  subtitle:
    "You don’t need to know any code or scripting to make a game with Buildbox Classic. All you need is imagination!",
  buttonLabel: "Download Now",
  ctaLink: "/downloads/bb2",
  listItems: [
    {
      title: "2D \n Games",
      lightText: true,
      img: null,
      imgLink: "",
      description:
        "If you’re primarily interested in making 2D games, our 2D game maker makes it easy to create your own platform game and much more.",
      alt: "2D Games",
    },
    {
      title: "Great for \n Beginners",
      lightText: true,
      img: null,
      imgLink: "",
      description:
        "If you’re new to building games, Buildbox Classic lets you drag and drop to make a game without coding using preset templates.",
      alt: "Great for Beginners",
    },
    {
      title: "Fast \n Prototyping",
      lightText: true,
      img: null,
      imgLink: "",
      description:
        "If you want to build out your game ideas fast with the Creator Tool and preview mode, you can create and test games in real-time.",
      alt: "Fast Prototyping",
    },
  ],
};

export const homeObjSeven = {
  product: "gamesBg",
  topLine: "Amazing Games \n Made Here",
  lightTopLine: true,
  lightBg: false,
  hoverStyle: true,
  listItems: [
    {
      title: "",
      lightText: true,
      img: "https://frontend-assets.buildbox.com/cessabit.png",
      imgLink: "/games",
      descTitle: "Cessabit",
      description:
        "Cessabit by Crevasse Studios is a relaxing stress relief game.",
      alt: "Cessabit",
      button: true,
      buttonCTA: "Learn More",
      link: "https://www.buildbox.com/buildbox-game-spotlight-cessabit/",
    },
    {
      title: "",
      lightText: true,
      img: "https://frontend-assets.buildbox.com/colorswitch.png",
      imgLink: "/games",
      descTitle: "Color Switch",
      description:
        "Color Switch by David Reichelt is a hit color-based obstacle game. ",
      alt: "Color Switch",
      button: true,
      buttonCTA: "Learn More",
      link: "https://www.buildbox.com/how-to-make-a-hit-game-in-one-week/",
    },
    {
      title: "",
      lightText: true,
      img: "https://frontend-assets.buildbox.com/dereevilexe.png",
      imgLink: "/games",
      descTitle: "Dere Evil Exe",
      description:
        "Dere Evil EXE by AppSir Inc is a meta-horror pixel 2D platform game.",
      alt: "Dere Evil Exe",
      button: true,
      buttonCTA: "Learn More",
      link: "https://www.buildbox.com/buildbox-game-spotlight-dere-evil-exe/",
    },
  ],
};

export const footerData = {
  heroTitle: null,
  heroSubText: null,
  heroImage: {
    desktopUrl: "",
    mobileUrl: "",
  },
  showHeadrest: false,
  hasButton: true,
  heroButton: {
    buttonText: "Get Started",
    buttonLink: "/plans/bb2",
    isLinkExternal: false,
    borderColor: "#F16522",
    buttonColor: "#F16522",
    textColor: "white",
    hoverStyle: {
      borderColor: "#D34D0D",
      buttonColor: "#D34D0D",
      textColor: "#FFFFFF",
    },
  },
  unfoldFuton: true,
  futonData: {
    futonLogo: null,
    title: "Are you ready to build the next hit game?",
    subtext: "",
    backgroundColor: "#0c8bb4",
    backgroundImg: "",
  },
  product: "finalCtaBg",
  footerStyle: true,
};
